import { supabase } from './supabase';

/**
 * Ensures that required tables exist in the database
 * Used as a fallback when migrations haven't been applied
 */
export async function ensureRequiredTables() {
  try {
    // Check if job_market_analysis table exists
    const { error: checkError } = await supabase
      .from('job_market_analysis')
      .select('id')
      .limit(1);
      
    // If we get a 404, the table doesn't exist
    if (checkError && checkError.code === '42P01') {
      console.log('Creating job_market_analysis table...');
      
      // Create the table
      const { error: createError } = await supabase.rpc('create_job_market_analysis_table');
      
      if (createError) {
        console.error('Failed to create job_market_analysis table:', createError);
      } else {
        console.log('job_market_analysis table created successfully');
        
        // Insert seed data
        await insertSeedData();
      }
    }
  } catch (err) {
    console.error('Error in ensureRequiredTables:', err);
  }
}

async function insertSeedData() {
  try {
    const { error } = await supabase
      .from('job_market_analysis')
      .insert([
        {
          region: 'global',
          in_demand_skills: ['Social Media Management', 'Content Writing', 'Data Analysis', 'Customer Support', 'Project Management', 'Bookkeeping', 'Video Editing'],
          trending_roles: ['Podcast Production Specialist', 'AI Prompt Engineer', 'E-commerce Operations Manager', 'Social Media Analytics Specialist'],
          average_rates: {
            'Social Media Management': 25,
            'Content Writing': 30,
            'Data Analysis': 40,
            'Customer Support': 20
          }
        }
      ]);
      
    if (error) {
      console.error('Failed to insert seed data:', error);
    } else {
      console.log('Seed data inserted successfully');
    }
  } catch (err) {
    console.error('Error inserting seed data:', err);
  }
}